import React from 'react';
import ClassesListView from '../components/ClassesListView';

const StudentClasses = () => {
  return (
    <ClassesListView 
      visaType="Student" 
      title="Student Visa Classes" 
    />
  );
};

export default StudentClasses;
